import { render } from "./SaleView.vue?vue&type=template&id=4a80ec42&scoped=true"
import script from "./SaleView.vue?vue&type=script&lang=js"
export * from "./SaleView.vue?vue&type=script&lang=js"

import "./SaleView.vue?vue&type=style&index=0&id=4a80ec42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a80ec42"]])

export default __exports__